/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Umar Hasnain",
  title: "Hi all, I'm Umar",
  subTitle: emoji(
    "A Passionate Frontend Web Developer 🚀 having an experience of building Web Development with HTML / CSS / JavaScript / TypeScript / React JS / Next JS / PWA / Firebase and some other cool libraries and frameworks."
  ),
  resumeLink: "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/umarhasnain",
  linkedin: "https://www.linkedin.com/in/umarhasnain/",
  gmail: "umarhasnain045@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/umarhasnain078",
  // medium: "https://medium.com/@umarhasnain",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FRONT END DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA )."),
    emoji("⚡ Integration of third party services such as Firebase")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS-3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "BootStrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },

    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Intermediate",
      logo: require("./assets/images/bieklogo.png"),
      subHeader: "Board of Intermediate Education Karachi"
      // duration: "September 2017 - April 2019",
      // desc: "Participated in the research of XXX and published 3 papers.",
    },
    {
      schoolName: "SMIT",
      logo: require("./assets/images/download.png"),
      subHeader: "Web & App Development",

      desc: "Learning Web & App Development Technologies like: HTML, CSS, BootStrap, Tailwind CSS, JavaScript, TypeScript, React JS, Next JS, PWA, Firebase, MongoDB, ExpressJS, NodeJS,React Native."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Problem Solving",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Front-End Developer Intern",
      company: "SMIT",
      companylogo: require("./assets/images/download.png"),
      // date: "June 2018 – Present",
      desc: "Onsite Frontend Web Development Internship Program.",
      descBullets: [
        "Make Some Projects",
        "Ecommerce Web, Quiz App, Blog App, Morent Car Rental App, OLX-Clone, NFT Clone, Calculator App, Weather App, Todo App, Pepsi Website Clone."
      ]
    }
    // {
    //   role: "Front-End Developer",
    //   company: "Quora",
    //   companylogo: require("./assets/images/quoraLogo.png"),
    //   date: "May 2017 – May 2018",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Airbnb",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   date: "Jan 2015 – Sep 2015",
    //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECTS THAT I HAVE CREATEED",
  projects: [
    {
      image: require("./assets/images/comfyti.png"),
      projectName: "Comfyti E-commerce",
      projectDesc:
        "Comfyti is a sleek e-commerce platform built with React.js and Tailwind CSS for a responsive design. It utilizes Firebase for seamless CRUD operations and features a dedicated admin dashboard for easy product and order management. Shop in comfort and style with Comfyti!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://comfyti.web.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/quizapp.png"),
      projectName: "Student Quiz App",
      projectDesc:
        "The Student Quiz App is an interactive tool built with HTML, CSS, and JavaScript. It uses Firebase for real-time data storage and user management, allowing students to create quizzes and view their results instantly. Test your knowledge in a fun way!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://umarhasnain.github.io/Student-Quiz-App/"
        }
      ]
    },
    {
      image: require("./assets/images/blog.png"),
      projectName: "Blog App",
      projectDesc:
        "Trend Rise is a dynamic blogging platform built with HTML, CSS, and JavaScript. Users can sign up or sign in to create and manage their own blogs, with Firebase enabling real-time data storage. Share your thoughts and connect with fellow writers!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://umarhasnain.github.io/blogs-app/"
        }
      ]
    },
    {
      image: require("./assets/images/morent.png"),
      projectName: "Morent Car Rental Web",
      projectDesc:
        "Morent is an intuitive car rental website built with HTML and CSS. It offers a user-friendly interface for browsing and booking vehicles, providing essential information and seamless navigation. Experience hassle-free car rentals with Morent!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://morent-web.netlify.app/"
        }
      ]
    },

    {
      image: require("./assets/images/images.png"),
      projectName: "Registration Chat Bot",
      projectDesc:
        "The Registration Chatbot is an interactive tool built with HTML, CSS, and JavaScript. It guides users through the registration process in a conversational format, making sign-ups easy and engaging. Streamline your onboarding experience with this friendly chatbot!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://umarhasnain.github.io/chat-bot/"
        }
      ]
    },
    {
      image: require("./assets/images/weather.png"),
      projectName: "Weather App",
      projectDesc:
        "The Weather App is a sleek, interactive application built with HTML, CSS, and JavaScript, utilizing the Open Weather API. Users can easily check current weather conditions and forecasts for any location, providing a seamless and informative experience. Stay updated with real-time weather information!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://umarhasnain.github.io/Weather-App/"
        }
      ]
    },

    {
      image: require("./assets/images/todo.png"),
      projectName: "Todo App",
      projectDesc:
        "The To-Do App is a simple and effective task management tool built with HTML, CSS, and JavaScript. It uses local storage to save tasks, allowing users to create, edit, and delete to-do items effortlessly. Stay organized and on top of your tasks!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://umarhasnain.github.io/Todo-App/"
        }
      ]
    },
    {
      image: require("./assets/images/olx.png"),
      projectName: "OLX Website Clone",
      projectDesc: "The OLX Web Clone is a user-friendly platform built with HTML and CSS for buying and selling goods. It features a clean interface for listing items, browsing categories, and connecting buyers and sellers. Experience a simplified marketplace with this clone!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://olx-frontpage.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/nft.png"),
      projectName: "NFT Website Clone",
      projectDesc: "The NFT Web Clone is a stylish platform built with HTML and CSS for showcasing and trading digital art. It features a visually appealing interface for browsing, buying, and selling NFTs, providing a seamless user experience in the growing digital marketplace. Dive into the world of NFTs!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://clone-nft.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Space-Logo-2002.png"),
      projectName: "Space Website Clone",
      projectDesc: "The Space Web Clone is an engaging platform built with HTML and CSS, designed to explore and learn about space. It features a visually appealing interface that showcases information on planets, stars, and galaxies, offering users an exciting journey through the cosmos. Discover the universe at your fingertips!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://space-website-clone.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/pepsi.png"),
      projectName: "Pepsi Website Clone",
      projectDesc: "The Pepsi Web Clone is a vibrant and engaging website built with HTML and CSS, designed to showcase Pepsi's products and brand. It features a visually appealing layout with product information, promotions, and multimedia elements, providing an immersive experience for fans of the iconic beverage. Enjoy the taste of Pepsi online!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://landing-pagepepsi.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Certificate of JavaScript Essentials",
      subtitle:
        "Certified in JavaScript Essentails.",
      image: require("./assets/images/cisco essentail.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/13gUzYgnRQ-KMS06IsgG-0vLrDY2fu81L/view?usp=drive_link"
        }
      ]
    },
    {
      title: "Certificate of Network Security",
      subtitle:
        "Certified in Network Security.",
      image: require("./assets/images/cisco essentail.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1Amhj54Cxn-iQ8Ob7625-Msyo2MB5uV4z/view?usp=sharing"
        }
      ]
    },
    {
      title: "Certificate of Appreciation",
      subtitle:
        "Certificate in Appreciation.",
      image: require("./assets/images/devtown.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1VtATeoGPU9402YmT8VctxKYvG8p5sMh3/view?usp=drive_link"
        }
      ]
    },
    {
      title: "Certificate of Participation",
      subtitle:
        "Certificate in Participation.",
      image: require("./assets/images/devtown.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1PMG57zm_FdBZYFfN32A1UcMpWzjlXg64/view?usp=sharing"
        }
      ]
    },
    {
      title: "Certificate of JavaScript Crash Course",
      subtitle:
        "Certificate in JavaScript Crash Course.",
      image: require("./assets/images/smitlog.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1yIx1AEa5tiwjzjV4lEC4GIwluksu57NV/view?usp=drive_link"
        }
      ]
    },
    {
      title: "Certificate of Participation",
      subtitle:
        "Certificate in Participation.",
      image: require("./assets/images/SSUET_Logo.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1bdd1I7NYSAz2LXp7vmn75yRHwDS7wDvV/view?usp=drive_link"
        }
      ]
    },


  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3151025098",
  email_address: "umarhasnain045@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
